const AvailableTracks = [
  {
    value: 0,
    label: 0
  },
  {
    value: 2,
    label: 2
  },
  {
    value: 4,
    label: 4
  },
  {
    value: 8,
    label: 8
  },
  {
    value: 16,
    label: 16
  }
];

export default AvailableTracks;
